import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "@/services/api";
import type { Appointment, IAppointmentState } from "./types";

export const fetchAppointmentData = createAsyncThunk(
  'appointment/fetchAppointmentData',
  async (id: string) => {
    const response = await api.get(`appointments/info/${id}`);

    return response.data.data;
  }
);

const initialState: IAppointmentState = {
  appointment: null,
  loading: false,
  error: false,
};

const appointmentSlice = createSlice({
  name: "appointment",
  initialState,
  reducers: {
    toggleAppointmentLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setAppointmentData(state, action: PayloadAction<Appointment>) {
      state.appointment = action.payload;
    }
  },
    extraReducers: (builder) => {
      builder
        .addCase(fetchAppointmentData.pending, (state) => {
          state.loading = true;
          state.error = false;
        })
        .addCase(fetchAppointmentData.fulfilled, (state, action) => {
          state.appointment = action.payload;
          state.loading = false;
        })
        .addCase(fetchAppointmentData.rejected, (state) => {
          state.loading = false;
          state.error = true;
        });
    },
});

export const { toggleAppointmentLoading } = appointmentSlice.actions;

export default appointmentSlice.reducer;
